export default (state = [], action = {}) => {
    if (action.type === 'GET_SUBJECT_LIST_SUCCESS') {
        return action.payload;
    }
    return state;
};
